import React from 'react';
import { oneOf } from 'prop-types';
import styled from 'styled-components';
import { spacing } from 'TMDesignSystem/spacing';

const StyledDivider = styled.hr`
    border: none;
    height: 1px;
    background-color: ${({ theme, variant }) => {
        switch (variant) {
            case 'light':
                return theme.colorSystem.UIElements[4];
            case 'medium':
                return theme.colorSystem.UIElements[9];
            case 'dark':
                return theme.colorSystem.UIText[1];
            default:
                return theme.colorSystem.UIElements[9];
        }
    }};
    margin: ${({ spacing: spacingProp }) => {
        switch (spacingProp) {
            case 'small':
                return `${spacing.medium} 0`;
            case 'medium':
                return `${spacing.mediumLarge} 0`;
            case 'large':
                return `${spacing.xLarge} 0`;
            default:
                return `${spacing.mediumLarge} 0`;
        }
    }};
    width: 100%;
`;

const Divider = ({ variant, dividerSpacing: spacingProp }) => (
    <StyledDivider variant={variant} spacing={spacingProp} />
);

Divider.propTypes = {
    variant: oneOf(['light', 'medium', 'dark']),
    dividerSpacing: oneOf(['small', 'medium', 'large'])
};

Divider.defaultProps = {
    variant: 'medium',
    dividerSpacing: 'medium'
};

export default Divider;
